"use client";

import React from "react";

export function Header15() {
  return (
    <section id="relume" className="bg-wood-green text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        <div className="rb-12 mb-12 grid grid-cols-1 items-start gap-x-12 gap-y-5 md:mb-18 md:grid-cols-2 md:gap-y-8 lg:mb-20 lg:gap-x-20 lg:gap-y-16">
          <div>
            {/* Opravené zalomení nadpisu */}
            <h1 className="text-[40px] font-bold font-serif leading-[1.1] md:text-[46px]">
              Stavíme a obnovujeme <br /> tradiční dřevěné domy <br /> a památkově chráněné <br /> objekty
            </h1>
          </div>
          <div>
            <p className="text-base md:text-lg leading-[1.6]">
            Dřevo má paměť. My ji respektujeme. Každý dům na Šluknovsku, v severních Čechách či na Kokořínsku, každá podstavková stavba či obnova památky v okolí Českého středohoří, je příběh jejich dědictví, který chceme vyprávět správně.
            </p>
            <div className="mt-6 flex flex-wrap gap-4 md:mt-8">
              {/* TLAČÍTKO VOLAT */}
              <a 
                href="tel:+420723856780" 
                className="px-8 py-3 bg-white text-wood-green font-bold rounded-full hover:bg-opacity-90 transition-all inline-block text-center"
              >
                VOLAT
              </a>
              {/* TLAČÍTKO KONTAKT (MAIL) */}
              <a 
                href="mailto:jiri@tesarstvi-sindelar.cz" 
                className="px-8 py-3 border border-white text-white font-bold rounded-full hover:bg-white/10 transition-all inline-block text-center"
              >
                jiri@tesarstvi-sindelar.cz
              </a>
            </div>
          </div>
        </div>
        <div>
          {/* Tento obrázek FUNGUJE - až budeš mít svou fotku, přepiš tuhle adresu */}
          <img
            src="img/Image stavba.png"
            className="w-full object-cover rounded-lg"
            alt="Realizace tesařství Šindelář"
          />
        </div>
      </div>
    </section>
  );
}